import { render, staticRenderFns } from "./RichListDisplay.vue?vue&type=template&id=5a9935b0&scoped=true"
import script from "./RichListDisplay.vue?vue&type=script&lang=js"
export * from "./RichListDisplay.vue?vue&type=script&lang=js"
import style0 from "./RichListDisplay.vue?vue&type=style&index=0&id=5a9935b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9935b0",
  null
  
)

export default component.exports